import { render, staticRenderFns } from "./Systemmessage.vue?vue&type=template&id=23d75170"
import script from "./Systemmessage.vue?vue&type=script&lang=js"
export * from "./Systemmessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports